import { render, staticRenderFns } from "./PriceChartEntry.vue?vue&type=template&id=2324d579&"
import script from "./PriceChartEntry.vue?vue&type=script&lang=js&"
export * from "./PriceChartEntry.vue?vue&type=script&lang=js&"
import style0 from "./PriceChartEntry.vue?vue&type=style&index=0&id=2324d579&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports